import type { BlogPost } from '../types';

export const post: BlogPost = {
  "id": "357",
  "slug": "spot-portugal-from-satellite-imagery",
  "title": "How to Recognise Portugal in Satellite Images",
  "excerpt": "Mainland Portugal occupies the Atlantic side of Iberia.",
  "date": "2026-06-05",
  "category": "Geography",
  "image": "/blog-images/portugal.jpg",
  "readTime": "1 min",
  "author": "EarthGuessr Team",
  "content": [
    {
      "type": "paragraph",
      "text": "Mainland Portugal occupies the Atlantic side of Iberia. The Tagus estuary at Lisbon makes a useful anchor: a narrow entrance opens into a much broader body of water inland. Farther south, the Sado estuary and the turn toward the Algarve provide another coastal sequence to trace."
    },
    {
      "type": "heading",
      "text": "Checking the location"
    },
    {
      "type": "paragraph",
      "text": "Compare this coast with Galicia to the north, where drowned valleys create deep inlets. Inland farming patterns and dry summer colours overlap with western Spain and cannot establish the border. This regional image covers the mainland; Madeira and the Azores are separate Atlantic island groups and need their own comparison."
    }
  ],
  "imageAlt": "Portugal regional satellite composite with shaded relief",
  "imageCaption": "NASA Earth Observatory / MODIS, August 2004. Regional composite with shaded relief and bathymetry; it shows landforms, not political boundaries or current conditions.",
  "sources": [
    {
      "title": "NASA: Blue Marble Next Generation (image source)",
      "url": "https://science.nasa.gov/earth/earth-observatory/blue-marble-next-generation/"
    }
  ]
};
